<script>
import Cookies from "js-cookie";

// import { useUserStore } from '@/stores'
import { RouterLink, useRouter } from "vue-router";
import { mapState } from "vuex";
import user from "../../store/user";
// const userStroe = useUserStore()
// const router = useRouter()
const confirm = () => {
  // 1。清除用户数据
  //   userStroe.clearUserInfo()
  // 跳转到登录页
  // router.push('/login')
};
export default {
  data() {
    return {
      la: "",
      token: "",
    };
  },
  // created() {
  //   this.laChange()
  // },
  computed: {
    ...mapState(["test"]),
  },
  mounted() {
    this.checkLoginStatus();
  },

  methods: {
    // 跳转到选品中心
    goSelection() {
      const token = localStorage.getItem('token')
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const url = window.location.href
      const a = document.createElement('a')
      a.target = '_blank'
      if (token) {
        if (userInfo.isVIP == 0) {
          this.$router.push({
            path: "/selection"
          })
          return
        }
        if (url.indexOf('gyh-sit') > -1) {//测试环境
          a.href = `https://open-api.alibaba.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://gyhconsole-sit.apbenben.com/authorization&client_id=504334`
          // a.href = `https://gyhconsole-sit.apbenben.com/authorization?token=${token}`
        } else {
          a.href = `https://open-api.alibaba.com/oauth/authorize?response_type=code&force_auth=true&redirect_uri=https://admin.gyhauto.com/authorization&client_id=504334`
          // a.href = `https://admin.gyhauto.com/authorization?token=${token}`
        }
        a.click()
      } else {
        // 没有入驻的商家跳转至介绍页
        this.$router.push({
          path: "/selection"
        })
      }
    },
    laChange() {
      const toLa = Cookies.get("language") == "en" ? "zh" : "en";
      Cookies.set("language", toLa);
      localStorage.setItem("language", toLa);
      window.location.reload();
    },
    logout() {
      this.$confirm(this.$i18n.t("是否退出登录?"), this.$i18n.t("提示"), {
        confirmButtonText: this.$i18n.t("确定"),
        cancelButtonText: this.$i18n.t("取消"),
        type: "warning",
      }).then(() => {
        localStorage.removeItem("token");
        window.location.reload();
        this.$message({
          type: "success",
          message: this.$i18n.t("退出登录成功!"),
        });
      });
    },
    checkLoginStatus() {
      const token = localStorage.getItem("token");
      this.token = token;
    },
  },
};
</script>

<template>
  <nav class="app-topnav">
    <div class="container flex-row main_text">
      <div class="welcome">
        Hi~{{ $t("欢迎来到广园汇汽配港!") }}
        <span class="ml-10" v-if="!token">
          <RouterLink to="/login">[{{ $t("登录") }}] </RouterLink>
        </span>
        <span class="ml-10" v-if="!token">
          <RouterLink to="/register">[{{ $t("注册") }}]</RouterLink>
        </span>
        <span class="ml-10" v-else @click="logout"><a>[{{ $t("退出登录") }}]</a></span>
      </div>
      <div>
        <ul class="">
          <!-- 判断是否登录状态  从而显示不一样的菜单栏-->
          <!-- <template v-if="userStroe.userInfo.token">
            <li>
              <a href="javascript:;"
                ><i class="iconfont icon-user"></i
                >{{ userStroe.userInfo.nickname }}</a
              >
            </li>
            <li>
              <el-popconfirm
                title="确认退出吗?"
                confirm-button-text="确认"
                cancel-button-text="取消"
                @confirm="confirm"
              >
                <template #reference>
                  <a href="javascript:;">退出登录</a>
                </template>
</el-popconfirm>
</li>
<li><a href="javascript:;">我的订单</a></li>
<li>
  <RouterLink :to="'/member'">会员中心</RouterLink>
  <a href="javascript:;" @click="router.push('/member')">会员中心</a>
</li>
</template> -->

          <template>
            <!-- <li>
              <RouterLink :to="'/login'">请先登录</RouterLink>
            </li> -->
            <li>
              <RouterLink :to="'/my/my_businees_publish'">
                {{ $t("我的") }}
              </RouterLink>
            </li>
            <li @click="laChange">
              <a href="javascript:;"><span :class="this.$cookie.get('language') == 'en' ? '' : 'active'">中文</span>
                /
                <span :class="this.$cookie.get('language') == 'en' ? 'active' : ''">English</span></a>
            </li>
            <li>
              <a href="javascript:;">{{ $t("帮助中心") }}</a>
            </li>
            <li>
              <span @click="goSelection" class="selection">{{ $t("选品中心") }}</span>
            </li>
            <li>
              <router-link to="/aboutUs">{{ $t("关于我们") }}</router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<style scoped lang="scss">
.app-topnav {
  background: #333;

  .main_text {
    align-items: center;
    justify-content: space-between;

    .active {
      color: #279c5f;
      font-size: 18px;
      font-weight: 600;
    }

    ul {
      display: flex;
      height: 53px;
      justify-content: flex-end;
      align-items: center;

      li {

        a,
        .selection {
          padding: 0 15px;
          color: #cdcdcd;
          line-height: 1;
          display: inline-block;

          i {
            font-size: 14px;
            margin-right: 2px;
          }

          &:hover {
            color: #27ba9b;
          }
        }

        .selection {
          cursor: pointer;
        }

        ~li {

          a,
          .selection {
            border-left: 2px solid #666;
          }
        }
      }
    }

    .welcome {
      height: 61px;
      line-height: 53px;
      color: #cdcdcd;

      a {
        color: #cdcdcd;
      }
    }
  }
}
</style>
